import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { listSeasons } from "../api/seasons.js";
import type { WireSeason } from "../api/types.js";
import { useApiClient } from "../api/ApiClientContext.js";

/**
 * Seasons already come back sorted the way the counter expects (the unnamed
 * open season first, then closed seasons newest-year-first — `sortSeasons`,
 * `@skladiscenje/core`, applied server-side in `routes/seasons.ts`), so this
 * hook does no re-sorting of its own.
 */
export function useSeasons(): UseQueryResult<WireSeason[]> {
  const client = useApiClient();
  return useQuery({
    queryKey: ["seasons"],
    queryFn: async () => (await listSeasons(client)).seasons,
  });
}
